<template>
  <v-row no-gutters style="height: 100%">
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12" class="mt-4">
          <span class="text-subtitle-2">
            {{ $t('message.pages.drm.screenTime') }}
          </span>
        </v-col>
        <v-col cols="12" class="mt-6">
          <v-slider
            v-model="group.percentTs"
            class="align-center"
            :max="slider.max"
            :min="slider.min"
            hide-details
          >
            <template v-slot:append>
              <v-text-field
                v-model="sliderPercantage"
                readonly
                dense
                class="justify-center align-center centered-input"
                hide-details
                outlined
                style="width: 80px"
              >
              </v-text-field>
            </template>
          </v-slider>
        </v-col>
        <v-col cols="12" class="mt-4 mb-3">
          <v-card flat class="v-card__preload">
            <span
              class="text-subtitle-2 font-weight-medium brand--text text--darken-2"
            >
              {{ $t('message.pages.drm.preloadCard.title') }}
            </span>
            <v-row no-gutters>
              <v-col cols="10">
                <p
                  class="text-subtitle-2 font-weight-regular neutral--text text--lighten-1 mb-0 mt-1"
                >
                  {{ $t('message.pages.drm.preloadCard.subtitle') }}
                </p>
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <p
                  class="text-subtitle-1 font-weight-regular neutral--text mb-0"
                >
                  {{ preloadTime }}
                </p>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-3">
              <v-col class="container__img-preload">
                <img
                  :src="
                    require(`@/assets/preload-${$i18next.resolvedLanguage}.svg`)
                  "
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="d-flex justify-end align-end pb-4">
      <v-card width="100%" flat>
        <v-card-actions>
          <v-spacer />
          <v-btn
            min-width="140px"
            text
            class="mr-2"
            :disabled="isFetching"
            @click="handleCloseModal"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            min-width="140px"
            color="primary"
            :disabled="isFetching || !hasEditDrmPerm"
            :loading="isFetching"
            @click="handleUpdate"
          >
            <span class="mx-2"> {{ $t('message.actions.save') }} </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'
import { mapMutations } from 'vuex'
import { addSeconds, format } from 'date-fns'

export default {
  name: 'DrmScreenTime',
  components: {},
  props: {
    drmGroup: Object,
    handleCloseModal: Function,
  },
  data: () => ({
    isFetching: false,
    groupId: '',
    group: {
      percentTs: 10,
    },
    slider: {
      value: 10,
      max: 100,
      min: 0,
    },
  }),
  computed: {
    sliderPercantage: {
      get() {
        return `${this.group.percentTs}%`
      },
    },
    preloadTime() {
      let finalValue = 12
      const percentageByTen = Number(Math.floor(this.group.percentTs / 10))
      finalValue = 4 * percentageByTen
      if (finalValue < 12) finalValue = 12
      if (finalValue > 32) finalValue = 32
      return format(
        addSeconds(new Date(0, 0, 0, 0, 0, 0, 0), finalValue),
        'mm:ss'
      )
    },
    hasEditDrmPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-watermark') ??
        false
      )
    },
  },
  watch: {
    drmGroup: {
      immediate: true,
      handler(val) {
        this.groupId = val.id
        this.group.percentTs = val.percent_ts * 100 || 10
      },
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
    ]),
    async handleUpdate() {
      this.isFetching = true
      let groupObject = {
        percent_ts: this.group.percentTs / 100,
      }
      try {
        let ret = await drmApi.drmUpdateVideos(this.groupId, groupObject)
        this.isFetching = false
        this.$root.$emit('updateDrmGroup', ret.data)
        this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(true)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: 'Configurações salvas com sucesso!',
        })
        this.handleCloseModal()
      } catch (e) {
        this.isFetching = false
        console.log('e', e)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.centered-input >>> input {
  text-align: center;
}

.v-card__preload {
  background: var(--v-brand-lighten3);
  padding: 16px;
  border-radius: 4px;
}

.container__img-preload {
  display: flex;
  justify-content: center;

  img {
    height: 245px;
  }
}
</style>
